import React from "react";
import { Chip, styled, TableCell, TableRow } from "@mui/material";
import { TransactionMasterData } from "types/models/transactionMaster/TransactionMasterApp";
import { formatIST } from "@crema/utility/Utils";

const uniformWidth = "150px";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",   // allow wrapping
  wordBreak: "break-word", // break long words if needed
  maxWidth: 180,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: TransactionMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  return (
    <TableRow key={data.id} className="item-hover">
      <StyledTableCell align="left" title={data.id}>
        {data.id}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.Lead_EkycId}>
        New COF
      </StyledTableCell>
      <StyledTableCell align="left" title={data.CafId}>
        {data.CafId}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.FirstName}>
        {data.FirstName} {data.LastName}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.ContactNumber}>
        {data.ContactNumber}
      </StyledTableCell>
      <StyledTableCell align="left" sx={{ width: 150, maxWidth: 150 }}>
        {data.order_id?.slice(0, data.order_id.length / 2)}<br />
        {data.order_id?.slice(data.order_id.length / 2)}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.PaymentMode}>
        {data.PaymentMode}
      </StyledTableCell>
      <StyledTableCell align="left" sx={{ width: 150, maxWidth: 150 }}>
        {data.TransactionId?.slice(0, data.TransactionId.length / 2)}<br />
        {data.TransactionId?.slice(data.TransactionId.length / 2)}
      </StyledTableCell>

      <StyledTableCell align="left" title={data.updated_at}>
        <span>{formatIST(data.updated_at)}</span>
      </StyledTableCell>
      <StyledTableCell align="left" title={data.payableAmount}>
        ₹ {data.payableAmount}
      </StyledTableCell>
      {(() => {
        const raw = String(data?.txn_status ?? "").toLowerCase();
        const isSuccess = raw === "charged";
        const label = isSuccess ? "Success" : "Failed";
        return (
          <StyledTableCell align="left" title={label}>
            <Chip size="small" label={label} color={isSuccess ? "success" : "error"} />
          </StyledTableCell>
        );
      })()}
    </TableRow>
  );
};

export default TableItem;
